<template>
  <div>
    <b-form-group label="Área pai:">
      <SelectArea
        v-model="area.area_id"
        :disable_node="area.id"
        :multiple="false"
      />
    </b-form-group>

    <b-row align-v="center">
      <b-col cols="10" md="9">
        <b-form-group label="Nome:">
          <b-form-input
            v-model="area.nome"
            placeholder="Nome"
            :state="validateState('nome')"
          ></b-form-input>
          <b-form-invalid-feedback
            >Nome é um campo obrigatório.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col col>
        <b-form-group label="Status" v-slot="{ ariaDescribedby }">
          <b-form-checkbox
            v-model="area.status"
            name="status"
            switch
            :aria-describedby="ariaDescribedby"
          >
            {{ area.status ? "Ativo" : "Inativo" }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label="Descrição:">
      <b-form-textarea
        v-model="area.descricao"
        placeholder="Descrição"
      ></b-form-textarea>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import SelectArea from "../SelectArea.vue";

export default {
  mixins: [validationMixin],
  components: { SelectArea },
  data: () => ({}),
  validations: {
    area: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("areas", ["area"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.area[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.area.$touch();
      return !this.$v.area.$anyError;
    },
  },
  created() {},
};
</script>
<style>
.custom-control-label {
  cursor: pointer;
}
</style>
